<script lang="ts">
    import { getContext } from "svelte";
    import type { Writable } from "svelte/store";
    import { CellState, type Timer } from "@lib/types";
    import { logEvent } from "@lib/events";
    import ResetIcon from "@icons/Reset.svelte";

    const session = getContext<string>("session");
    const timer = getContext<Writable<Timer>>("timer");
    const placements = getContext<Writable<Array<CellState>>>("placements");
    const snapshots = getContext<Writable<Array<Array<CellState>>>>("snapshots");

    const canonicalState = (v: number) => {
        return v === CellState.StarInvalid ? CellState.Star : v;
    };

    const computeChanges = (before: Array<CellState>, after: Array<CellState>) => {
        const changes: Array<{ index: number; from: number; to: number }> = [];
        const n = Math.min(before.length, after.length);
        for (let i = 0; i < n; i++) {
            const from = canonicalState(before[i]);
            const to = canonicalState(after[i]);
            if (from !== to) {
                changes.push({ index: i, from, to });
            }
        }
        return changes;
    };

    const reset = () => {
        let changes: Array<{ index: number; from: number; to: number }> = [];
        placements.update((p) => {
            const before = p.slice();
            // Snapshot the current state case this was a mistake.
            snapshots.update((s: Array<Array<CellState>>) => {
                s.push(p.slice());
                return s;
            });

            // Reset everything.
            const after = p.map(() => CellState.Empty);
            changes = computeChanges(before, after);
            return after;
        });

        if (changes.length > 0) {
            void logEvent({
                session,
                event_type: "reset",
                elapsed_ms: $timer.elapsed,
                data: { changes },
            });
        }
    };
</script>

<button class="icon" onclick={reset}>
    <ResetIcon />
</button>
